import { useQuery } from "@/api/utils/useQuery"
import { customerNumberFromReferralCode } from "@/helpers/referralHelper"
import { parseReferral } from "@/models/operations/referral/referral.parser"
import {
  parseCustomerReferralCodeQuery,
  parseReferralCode,
} from "@/models/operations/referralCode/referralCode.parser"
import { parseReferralCodeDetail } from "@/models/operations/referralCodeDetails/referralCodeDetails.parser"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { ReferralCodeDetail } from "@/models/operations/referralCodeDetails/referralCodeDetails"

class ReferralServiceClass {
  getBlacklistedCodes() {
    return useQuery({
      ...HasuraQueries.referral.blacklistedCodes(),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) => (data ? data.customer.map(parseReferralCode) : []),
    })
  }

  getRecentReferrals(resultsCount) {
    return useQuery({
      ...HasuraQueries.referral.recentReferrals(resultsCount),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data ? data.customer_referrals.map(parseReferral) : [],
    })
  }

  getCustomerReferral(customerId: number) {
    return useQuery({
      ...HasuraQueries.referral.customer(customerId),
      useRawResponse: true,
      placeholderData: null,
      parserFn: (data) => parseCustomerReferralCodeQuery(data),
    })
  }

  getReferralCodeDetails(code: string): QueryResult<ReferralCodeDetail | null> {
    const customerNumber = customerNumberFromReferralCode(code)

    return useQuery({
      ...HasuraQueries.referral.customerDetails(customerNumber),
      placeholderData: null,
      useRawResponse: true,
      parserFn: (data) => {
        return data.customer.length
          ? parseReferralCodeDetail(data.customer[0])
          : null
      },
      enabled: !!customerNumber,
    })
  }
}

export const ReferralService = new ReferralServiceClass()
